var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchStar = function SvgSearchStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.38 18.003 4.362 2.878c.562.37 1.255-.18 1.09-.854l-1.263-5.164a.812.812 0 0 1 .016-.434.785.785 0 0 1 .235-.358l3.911-3.391c.51-.441.251-1.332-.415-1.377l-5.106-.342a.702.702 0 0 1-.385-.145.745.745 0 0 1-.246-.34L12.675 3.49a.743.743 0 0 0-.263-.356.7.7 0 0 0-.824 0 .744.744 0 0 0-.263.356L9.421 8.475a.745.745 0 0 1-.246.341.702.702 0 0 1-.385.145l-5.106.342c-.666.045-.926.936-.415 1.377l3.911 3.39a.81.81 0 0 1 .251.792l-1.168 4.786c-.2.81.632 1.466 1.298 1.025l4.058-2.671a.69.69 0 0 1 .762 0v0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchStar);
export default ForwardRef;